import { render, staticRenderFns } from "./BooleanFilterSummary.vue?vue&type=template&id=49df3f12&scoped=true"
import script from "./BooleanFilterSummary.vue?vue&type=script&lang=js"
export * from "./BooleanFilterSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df3f12",
  null
  
)

export default component.exports